import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"
import { createBrowserRouter, createHashRouter, RouterProvider, useParams } from "react-router-dom";

import theme from "theme"
import routes from "routes";

// import { QueryProvider } from './providers/queryClientProvider';
import ApolloClientProvider from "providers/ApolloClientProvider";

import 'assets/styles/style.css'
import { useSelector } from "react-redux";
import Login from "views/Login";
import { State } from "state/reducers";
import { hasAnyAuthToeken } from "functions/auth";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { authCreator } from "./state";
import ResetPassword from "views/ResetPassword";
import AutoRegister from "views/AutoRegister";
import GlucoseRegister from "views/GlucoseRegister";
import GlucoseMonitoring from "views/GlucoseMonitoring";
import GlucoseValidate from "views/GlucoseValidate";

const router = createBrowserRouter(routes)
// const router = createHashRouter(routes);

export const App = () => {
	const { token: resetToken } = useParams();

	const dispatch = useDispatch();
	const { login } = bindActionCreators(authCreator, dispatch)
	const { token: stateToken } = useSelector(({ auth }: State) => auth)

	const localStorageToken = window.localStorage.getItem('token');
	const currentUrl = window.location.href;
	const authToken = hasAnyAuthToeken(stateToken, localStorageToken, login)


	return (
		<ChakraProvider theme={theme}>
			{
				currentUrl.includes("resetar")
					?
					<ResetPassword />
					:
					currentUrl.includes("cadastro")
						?
						<ApolloClientProvider>
							<AutoRegister />
						</ApolloClientProvider>
						:
						currentUrl.includes("glicemia-registro")
							?

							<ApolloClientProvider>
								<GlucoseRegister />
							</ApolloClientProvider>
							:
						currentUrl.includes("glicemia-monitoramento")
							?
							<ApolloClientProvider>
								<GlucoseMonitoring />
							</ApolloClientProvider>
							:
							currentUrl.includes("glicemia")
								?
								<ApolloClientProvider>
									<GlucoseValidate />
								</ApolloClientProvider>
								:
								authToken === null
									?
									<Login />
									:
									<ApolloClientProvider>
										<RouterProvider router={router} />
									</ApolloClientProvider>
			}
		</ChakraProvider>
	)
}